<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">
    <div class="page-heading">
      <h3>
        {{ 'billing.invoicing' | translate }}
      </h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [placeholder]="'billing.search' | translate" [(ngModel)]="searchText"
            (input)="onSearch()" autocapitalize="off" style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchText" (click)="searchText = ''; onSearch()" style="cursor: pointer;"></i>
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>{{ 'common.filter' | translate }}</span>
          <span *ngIf="hasActiveFilters()" class="filter-active-dot"
            (click)="clearAllFilters(); $event.stopPropagation()" title="{{ 'common.clear-filters-tooltip' | translate }}">
          </span>
        </button>
        <div class="dropdown export-dropdown">
          <button class="btn btn-export dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{ 'billing.export' | translate }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadInvoice()">
                <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
                PDF
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
                <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
                Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- AR Usage Card -->
    <div class="ar-usage-card">
      <div class="upgrade-plan-to-view" *ngIf="!hasArAccess">
        <div class="lock-badge" (click)="goToSubscription()">
          <svg width="16" height="21" class="open-lock" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 7H11V5C11 4.16667 10.7083 3.45833 10.125 2.875C9.54167 2.29167 8.83333 2 8 2C7.16667 2 6.45833 2.29167 5.875 2.875C5.29167 3.45833 5 4.16667 5 5H3C3 3.61667 3.4875 2.4375 4.4625 1.4625C5.4375 0.4875 6.61667 0 8 0C9.38333 0 10.5625 0.4875 11.5375 1.4625C12.5125 2.4375 13 3.61667 13 5V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V19C16 19.55 15.8042 20.0208 15.4125 20.4125C15.0208 20.8042 14.55 21 14 21H2C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7ZM2 19H14V9H2V19ZM8 16C8.55 16 9.02083 15.8042 9.4125 15.4125C9.80417 15.0208 10 14.55 10 14C10 13.45 9.80417 12.9792 9.4125 12.5875C9.02083 12.1958 8.55 12 8 12C7.45 12 6.97917 12.1958 6.5875 12.5875C6.19583 12.9792 6 13.45 6 14C6 14.55 6.19583 15.0208 6.5875 15.4125C6.97917 15.8042 7.45 16 8 16Z"
              fill="white" />
          </svg>
          <svg width="16" height="21" class="close-lock" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 7H11V5C11 4.16667 10.7083 3.45833 10.125 2.875C9.54167 2.29167 8.83333 2 8 2C7.16667 2 6.45833 2.29167 5.875 2.875C5.29167 3.45833 5 4.16667 5 5V7H4H3V5C3 3.61667 3.4875 2.4375 4.4625 1.4625C5.4375 0.4875 6.61667 0 8 0C9.38333 0 10.5625 0.4875 11.5375 1.4625C12.5125 2.4375 13 3.61667 13 5V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V19C16 19.55 15.8042 20.0208 15.4125 20.4125C15.0208 20.8042 14.55 21 14 21H2C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7ZM2 19H14V9H2V19ZM8 16C8.55 16 9.02083 15.8042 9.4125 15.4125C9.80417 15.0208 10 14.55 10 14C10 13.45 9.80417 12.9792 9.4125 12.5875C9.02083 12.1958 8.55 12 8 12C7.45 12 6.97917 12.1958 6.5875 12.5875C6.19583 12.9792 6 13.45 6 14C6 14.55 6.19583 15.0208 6.5875 15.4125C6.97917 15.8042 7.45 16 8 16Z"
              fill="white" />
          </svg>
          <span>{{ 'common.upgrade-plan' | translate }}</span>
        </div>
      </div>

      <h3 class="ar-usage-heading">{{ 'billing.arUsage.title' | translate }}</h3>

      <ng-container *ngIf="hasArAccess; else arUpsellCopy">
        <div class="ar-usage-count">
          <ng-container *ngIf="arUnlimited; else arLimitedCount">
            {{ 'billing.arUsage.unlimited' | translate }}
          </ng-container>
          <ng-template #arLimitedCount>
            {{ arCampaignsUsed }}<small>/{{ arCampaignsAllowed }} {{ 'billing.arUsage.usedOf' | translate }}</small>
          </ng-template>
        </div>
        <div class="ar-usage-progress">
          <div class="ar-usage-track">
            <div class="ar-usage-fill" [style.width.%]="arUsagePercent()"></div>
          </div>
        </div>
        <p class="ar-usage-reset-line">
          <ng-container *ngIf="arUnlimited; else arResetLine">
            {{ 'billing.arUsage.unlimitedBody' | translate }}
          </ng-container>
          <ng-template #arResetLine>
            <ng-container *ngIf="arUsageResetType === 'auto'; else arManualReset">
              {{ 'billing.arUsage.resetsOn' | translate }} {{ arUsageResetDate | date:'mediumDate' }}
            </ng-container>
            <ng-template #arManualReset>{{ 'billing.arUsage.contactSupport' | translate }}</ng-template>
          </ng-template>
        </p>
      </ng-container>
      <ng-template #arUpsellCopy>
        <p class="ar-usage-reset-line">{{ 'billing.arUsage.upsellBody' | translate }}</p>
      </ng-template>
    </div>

    <div class="billing-tabs">
      <button class="billing-tab" [class.active]="activeTab === 'invoice'" (click)="setActiveTab('invoice')">
        {{ 'billing.billingAndInvoice' | translate }} ({{ totalItems }})
      </button>
      <button class="billing-tab" [class.active]="activeTab === 'discounts'" (click)="setActiveTab('discounts')">
        {{ 'billing.discounts' | translate }} ({{ discountRows.length }})
      </button>
    </div>
    <!-- table -->
    <div class="luqta-card" *ngIf="activeTab === 'invoice'">
      <div class="card-heading">
        <h3>
          {{ 'billing.billingAndInvoice' | translate }} ({{ totalItems }})
        </h3>
      </div>
      <nz-table #contestTable [nzData]="filteredInvoice" [nzBordered]="true" [nzScroll]="{ x: '1950px' }"
        [nzShowSizeChanger]="true" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzTotal]="totalItems"
        [nzPageSizeOptions]="[10, 20, 50]" [nzShowPagination]="true" [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event)" (nzPageSizeChange)="onPageSizeChange($event)">
        <thead>
          <tr>
            <th nzWidth="150px">{{ 'billing.table.invoiceId' | translate }}</th>
            <!-- <th nzWidth="130px">Created Date</th> -->
            <th nzWidth="120px">{{ 'billing.table.startDate' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.table.endDate' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.table.planType' | translate }}</th>
            <th nzWidth="100px">{{ 'billing.table.mode' | translate }}</th>
            <th nzWidth="140px">{{ 'billing.original-amount' | translate }}</th>
            <th nzWidth="160px">{{ 'billing.price-adjustment' | translate }}</th>
            <th nzWidth="130px">{{ 'billing.table.paidAmount' | translate }}</th>
            <th nzWidth="140px">{{ 'billing.payment-method' | translate }}</th>
            <th nzWidth="150px">{{ 'billing.table.contestAllowed' | translate }}</th>
            <th nzWidth="150px">{{ 'billing.participants' | translate }}</th>
            <th nzWidth="150px">{{ 'billing.table.paymentStatus' | translate }}</th>
            <th nzWidth="80px" nzRight>{{ 'billing.download' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of contestTable.data">
            <td style="text-transform: none;" [innerHTML]="data.id | highlight: searchText"></td>
            <!-- <td style="text-transform: none;" [innerHTML]="data.created_date | highlight: searchText"></td> -->
            <td style="text-transform: none;" [innerHTML]="data.start_date | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="data.end_date | highlight: searchText"></td>
            <td style="text-transform: none;">
              <span [innerHTML]="data.plan_type | highlight: searchText"></span>
            </td>
            <td style="text-transform: none;">
              <span [innerHTML]="data.mode | highlight: searchText"></span>
              <img *ngIf="data._overrides?.mode" class="override-icon" src="assets/images/pencil-edit-02.svg"
                alt="" nz-tooltip [nzTooltipTitle]="getOverrideTooltip(data, 'mode', 'Mode') || ('billing.value-adjusted' | translate)">
            </td>
            <td style="text-transform: none;">{{ data.original_amount || 'N/A' }}</td>
            <td style="text-transform: none;">
              <ng-container *ngIf="data._raw_discount_saved && data._raw_discount_saved !== 0 && data._raw_discount_saved !== '0'; else noAdjustment">
                <span [style.color]="data._raw_discount_saved?.toString().startsWith('-') ? '#e74c3c' : '#27ae60'" style="font-weight: 600;">
                  {{ data._raw_discount_saved?.toString().startsWith('-') ? '-' : '+' }}${{ data._raw_discount_saved?.toString().replace('+','').replace('-','') }}
                </span>
              </ng-container>
              <ng-template #noAdjustment>—</ng-template>
            </td>
            <td style="text-transform: none;">
              <span [innerHTML]="data.paid_amount | highlight: searchText"></span>
              <img *ngIf="data._overrides?.paid_amount" class="override-icon" src="assets/images/pencil-edit-02.svg"
                alt="" nz-tooltip [nzTooltipTitle]="getOverrideTooltip(data, 'paid_amount', 'Paid Amount') || ('billing.value-adjusted' | translate)">
            </td>
            <td style="text-transform: none;" [innerHTML]="data.payment_method | highlight: searchText"></td>
            <td style="text-transform: none;">
              <span [innerHTML]="data.contest_allowed | highlight: searchText"
                [attr.title]="getOverrideTooltip(data, 'contest_allowed', 'Contest Allowed')"></span>
              <img *ngIf="data._overrides?.contest_allowed" class="override-icon" src="assets/images/pencil-edit-02.svg"
                alt="" nz-tooltip [nzTooltipTitle]="getOverrideTooltip(data, 'contest_allowed', 'Contest Allowed') || ('billing.value-adjusted' | translate)">
            </td>
            <td style="text-transform: none;">
              <span [innerHTML]="data.participants | highlight: searchText"
                [attr.title]="getOverrideTooltip(data, 'participants', 'Participants')"></span>
              <img *ngIf="data._overrides?.participants" class="override-icon" src="assets/images/pencil-edit-02.svg"
                alt="" nz-tooltip [nzTooltipTitle]="getOverrideTooltip(data, 'participants', 'Participants') || ('billing.value-adjusted' | translate)">
            </td>
            <td style="text-transform: none;">
              <span [ngClass]="getStatusClass(data.payment_status)"
                [innerHTML]="data.payment_status | highlight: searchText"></span>
            </td>
            <td nzRight style="text-align: center;">
              <button class="btn btn-sm" (click)="downloadSingleInvoice(data)" [title]="'billing.download-invoice' | translate"
                style="background: none; border: none; cursor: pointer;">
                <i class="fa-solid fa-download" style="color: #2c3e50; font-size: 16px;"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <div class="luqta-card" *ngIf="activeTab === 'discounts'">
      <div class="card-heading">
        <h3>
          {{ 'billing.discounts' | translate }} ({{ filteredDiscounts.length }})
        </h3>
      </div>
      <nz-table [nzData]="filteredDiscounts" [nzBordered]="true" [nzScroll]="{ x: '1200px' }"
        [nzShowPagination]="filteredDiscounts.length > 0" [nzPageSize]="10" [nzFrontPagination]="true">
        <thead>
          <tr>
            <th nzWidth="140px">{{ 'billing.invoice-id' | translate }}</th>
            <th nzWidth="160px">{{ 'billing.plan-type' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.mode' | translate }}</th>
            <th nzWidth="140px">{{ 'billing.original-amount' | translate }}</th>
            <th nzWidth="160px">{{ 'billing.price-adjustment' | translate }}</th>
            <th nzWidth="140px">{{ 'billing.final-amount' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.start-date' | translate }}</th>
            <th nzWidth="120px">{{ 'billing.end-date' | translate }}</th>
            <th nzWidth="120px">{{ 'common.status' | translate }}</th>
            <th nzWidth="80px" nzRight>{{ 'billing.download' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredDiscounts">
            <td style="text-transform: none;" [innerHTML]="row.invoice_id | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="row.plan_type | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="row.mode | highlight: searchText"></td>
            <td style="text-transform: none;">{{ row.original_amount }}</td>
            <td style="text-transform: none;">
              <span [style.color]="row._raw_discount_saved?.toString().startsWith('-') ? '#e74c3c' : '#27ae60'" style="font-weight: 600;">
                {{ row._raw_discount_saved?.toString().startsWith('-') ? '-' : '+' }}${{ row._raw_discount_saved?.toString().replace('+','').replace('-','') }}
              </span>
            </td>
            <td style="text-transform: none;">{{ row.discounted_amount }}</td>
            <td style="text-transform: none;" [innerHTML]="row.start_date | highlight: searchText"></td>
            <td style="text-transform: none;" [innerHTML]="row.end_date | highlight: searchText"></td>
            <td style="text-transform: none;">
              <span [ngClass]="getStatusClass(row.payment_status)"
                [innerHTML]="row.payment_status | highlight: searchText"></span>
            </td>
            <td nzRight style="text-align: center;">
              <button class="btn btn-sm" (click)="downloadSingleInvoice(row)" [title]="'billing.download-invoice' | translate"
                style="background: none; border: none; cursor: pointer;">
                <i class="fa-solid fa-download" style="color: #2c3e50; font-size: 16px;"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="filteredDiscounts.length === 0">
            <td colspan="10" class="text-center py-4">{{ 'billing.no-discounts' | translate }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>


    <!-- Payment Methods Section - Hidden for now -->
    <!-- <div class="current-payments-accounts-card">
      <div class="content">
        <img src="../../../../assets/images/accounts.png" alt="">
        <h4>
          {{ 'billing.paymentMethods' | translate }}
        </h4>
        <p>
          {{ 'billing.paymentMethodsDesc' | translate }}
        </p>
      </div>
      <div class="accounts">
        <h3>
          {{ 'billing.currentPaymentAccounts' | translate }}
        </h3>
        <div class="account-card" *ngFor="let card of cardList; trackBy: trackByCardId">
          <div class="cards-detail">
            <div class="logo">
              <img src="../../../../assets/images/mastercard.svg" alt="">
            </div>
            <span>
              {{ card.card_number | maskLast4 }}
            </span>
          </div>
          <div class="action-btns">
            <ng-container *ngIf="card.set_primary">
              <button class="btn btn-default">{{ 'billing.buttons.default' | translate }}</button>
              <button class="btn btn-edit" (click)="editCard(card.id)">{{ 'billing.buttons.edit' | translate }}</button>
            </ng-container>
            <ng-container *ngIf="!card.set_primary">
              <button class="btn btn-make-default" (click)="showConfirm(card)">{{ 'billing.buttons.makeDefault' |
                translate }}</button>
              <button class="btn btn-remove" (click)="deleteCard(card)">{{ 'billing.buttons.remove' | translate
                }}</button>
              <button class="btn btn-edit" (click)="editCard(card.id)">{{ 'billing.buttons.edit' | translate }}</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- Filter Modal -->
<app-filter-modal [(isVisible)]="filterModalVisible" [config]="filterConfig" [modalTitle]="'Filter Billing'"
  [initialFilters]="currentFilters" (filtersApplied)="onFiltersApplied($event)"
  (filtersReset)="onFiltersReset()"></app-filter-modal>
